import { setGlobalTheme } from '@atlaskit/tokens';

const THEME_KEY = 'app-theme';

export function bootstrapDesignSystem() {
  const stored = localStorage.getItem(THEME_KEY);
  const colorMode: 'light' | 'dark' =
    stored === 'light' || stored === 'dark'
      ? stored
      : window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';

  document.documentElement.setAttribute('data-color-mode', colorMode);

  setGlobalTheme({
    colorMode,
    light: 'light',
    dark: 'dark',
    spacing: 'spacing',
    typography: 'typography',
    shape: 'shape'
  });
}
